import React from "react";
import { TimeSeriesItem } from "~/modules/token_timeseries/types";
import { api } from "~/utils/api";
import { deobfuscate } from "~/utils/obfuscate";

// // // //

/**
 * ReferenceRatesFetcher
 * Fetches Secured Overnight Financing Rate (SOFR) data from the API
 */
export function ReferenceRatesFetcher(props: {
    children: (childProps: {
        data: TimeSeriesItem[];
        loading: boolean;
        error?: Error;
        refetch: () => void;
    }) => React.ReactNode;
}) {
    const { children } = props;

    const sofrReq = api.referenceRates.querySofrData.useQuery(undefined, {
        refetchOnWindowFocus: false,
        staleTime: Infinity,
        select: (data: unknown) => deobfuscate(data as string),
        trpc: { context: { skipBatch: true } },
    });

    return (
        <>
            {children({
                loading: sofrReq.isLoading,
                data: sofrReq.data ?? [],
                error: sofrReq.error as unknown as Error | undefined,
                refetch: () => void sofrReq.refetch(),
            })}
        </>
    );
}
